import { createAction } from 'src/lib/createAction';
import { EventListItemDTO } from 'src/common/models/event';

export const courseBundleEventsActions = {
  addEvents: createAction('courseBundle/courseBundleEvents/addEvents')<EventListItemDTO[]>(),
  clear: createAction('courseBundle/courseBundleEvents/clear')(),
  setEvents: createAction('courseBundle/courseBundleEvents/setEvents')<EventListItemDTO[]>(),
  setTotal: createAction('courseBundle/courseBundleEvents/setTotal')<number>(),
};
